<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.nickname"
              placeholder="人员昵称"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.bxPhone"
              placeholder="本香门店绑定手机号"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="门店名称"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.certificateNo"
              placeholder="专卖证号"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.grantResult"
              clearable
              placeholder="成长值发放结果"
              style="width: 100%;"
            >
              <el-option
                v-for="(data, index) in grantResultData"
                :key="index"
                :label="data.label"
                :value="data.value"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @match="handleMatch(arguments)"
        @cancelMatch="handleCancelMatch(arguments)"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 匹配零售户档案 -->
    <matching-dialog
      :data-id="id"
      :dialog-visible.sync="dialogMatchVisible"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-visible.sync="dialogViewVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 匹配
import matchingDialog from './components/matchingDialog';
// 查看
import viewDialog from './components/viewDialog'
// 直播活动参与人员API
import { loadLiveStreamingEventDetailListDataApi, exportLiveStreamingEventDetailListDataApi, cancelMatchingLiveStreamingEventDetailApi } from "@/api/v2/liveStreamingEventDetail";

export default {
  name: 'LiveStreamingEventDetailView',
  components: { CustomTable2, TableOperation2, matchingDialog, viewDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'live_streaming_event_detail_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['live_event_detail_match'],
            prop: 'match',
            label: '匹配睿零售用户',
            method: 'match'
          },
          {
            permissionSigns: ['live_event_detail_match'],
            prop: 'cancelMatch',
            label: '解除匹配',
            method: 'cancelMatch'
          },
          {
            permissionSigns: ['live_event_detail_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['live_event_detail_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          nickname: '',
          bxPhone: '',
          storeName: '',
          certificateNo: '',
          grantResult: '',
        },
      },
      grantResultData: [{ value: 1, label: "已发放" }, { value: 2, label: "未发放" }],
      id: null,
      dialogMatchVisible: false,
      dialogViewVisible: false,
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80, align: 'center' },
      { prop: 'provinceName', label: '省区', filterColumn: 'tlse.province_name', width: 90 },
      { prop: 'liveEventName', label: '直播活动名称', filterColumn: 'tlse.name', width: 220 },
      { prop: 'uid', label: '直播用户ID', filterColumn: "tlsed.uid", width: 120 },
      { prop: 'nickname', label: '昵称', filterColumn: 'tlsed.nickname', width: 150 },
      { prop: 'bxPhone', label: '本香绑定电话', filterColumn: 'tlsed.bx_phone', width: 130 },
      { prop: 'city', label: '市场', filterColumn: "ifnull(tau.city_name, '')", width: 100 },
      { prop: 'storeName', label: '门店名称', filterColumn: "ifnull(tau.store_name, '')", width: 200 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: "ifnull(tau.certificate_no, '')", width: 120 },
      { prop: 'area', label: '直播观看区域', filterColumn: 'tlsed.area', width: 150 },
      { prop: 'viewingDuration', label: '直播观看时长', filterColumn: 'tlsed.viewing_duration', width: 130 },
      { prop: 'reviewDuration', label: '回看时长', filterColumn: 'tlsed.review_duration', width: 120 },
      { prop: 'stayDuration', label: '直播停留时长', filterColumn: 'tlsed.stay_duration', width: 130 },
      { prop: 'liveLeaveTime', label: '离开直播间时间', filterColumn: 'tsqd.live_leave_time', width: 150, isBetween: true },
      { prop: 'growthValue', label: '成长值', filterColumn: 'tlse.growth_value', width: 90 },
      { prop: 'grantGrowthValueTime', label: '成长值发放时间', filterColumn: 'tlse.grant_growth_value_time', width: 150 },
      { prop: 'grantResultValue', label: '成长值发放结果', filterColumn: "(case tlsed.grant_value when 1 then '已发放' when 2 then '未发放' else '' end)", width: 140 },
      { prop: 'noGrantReason', label: '成长值未发放原因', filterColumn: 'tlsed.no_grant_reason', width: 300 },
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadLiveStreamingEventDetailListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 匹配
    handleMatch (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要匹配零售户档案的直播参与人员', type: 'warning' })
        return
      }
      if (args[0].appUserId > 0) {
        _this.$message({ message: '直播参与人员已成功匹配零售户档案', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogMatchVisible = !_this.dialogMatchVisible
    },
    // 取消匹配
    handleCancelMatch (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要取消匹配零售户档案的直播参与人员', type: 'warning' })
        return
      }
      if (args[0].appUserId === 0) {
        _this.$message({ message: '直播参与人员未成功匹配零售户档案，不能取消匹配', type: 'warning' })
        return
      }
      _this.$confirm('是否确认取消直播参与人员与零售户档案的匹配？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        cancelMatchingLiveStreamingEventDetailApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '取消匹配成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 查看
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的直播活动参与人员', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportLiveStreamingEventDetailListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
